import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_TEXT, PLAIN_TEXT } = COLORS;

type TextProps = {
  fontSize?: number;
  color?: string;
  maxLimitWidth?: number | string;
  fontWeight?: number;
};

export const useStyles = (styleProps: TextProps) =>
  makeStyles((theme) =>
    createStyles({
      root: {
        color:
          theme.palette.type === 'dark'
            ? styleProps.color
              ? styleProps.color
              : PLAIN_TEXT
            : styleProps.color
              ? styleProps.color
              : DARK_TEXT,
        fontSize: styleProps.fontSize,
        fontWeight:
          styleProps.fontWeight || (styleProps.color === DARK_TEXT || theme.palette.type === 'light' ? 500 : undefined),

        textTransform: 'initial',
      },
      limit__characters: {
        overflow: 'hidden',
        whiteSpace: styleProps.maxLimitWidth === 'unset' ? 'initial' : 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: styleProps.maxLimitWidth,
      },
    }),
  );
